<template>
  <expandable header="Treating Physician" class="mb-10">
    <b-row>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.treating_physician_name"
          label="Treating Physician Name"
          :disabled="isDisabled"
          @input="onInput"
          rules="max-150"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.treating_physician_contact"
          label="Contact Number"
          type="number"
          :disabled="isDisabled"
          @input="onInput"
          rules="integer"
        ></input-field>
      </b-col>
    </b-row>
  </expandable>
</template>

<script>
import Expandable from "../../Expandable.vue";
import InputField from "../../form/InputField.vue";

export default {
  components: { Expandable, InputField },
  props: {
    value: {},
    isDisabled: { default: false, type: Boolean },
  },
  data() {
    return { form: {} };
  },
  methods: {
    onInput() {
      this.$emit("input", this.form);
    },
  },
  beforeMount() {
    this.form = this.value;
  },
  mounted() {
    this.onInput();
  },
};
</script>
